import { Component } from '@angular/core';

@Component({
  selector: 'hoover-error',
  templateUrl: './error.component.html',
})
export class ErrorComponent {}
